// extracted by mini-css-extract-plugin
export default {"root":"style_root__x+ijA","flexWrap":"style_flexWrap__z8Elw","edit":"style_edit__7n3Rq","save":"style_save__fiTCF"};